var React = require('react');

function CandleHolder (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M160 192c45.93 0 78-32.61 78-79.29 0-30-32.59-74.89-78-112.71-45.62 38-78 82.84-78 112.71 0 46.68 32.07 79.29 78 79.29zm216 176a72.08 72.08 0 0 0-72 72 71.11 71.11 0 0 0 4.42 24H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h360a72 72 0 0 0 0-144zm0 96a24 24 0 1 1 24-24 24 24 0 0 1-24 24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 256v208H64V256a32 32 0 0 1 32-32h32v48a16 16 0 0 0 32 0v-48h64a32 32 0 0 1 32 32z","className":"fa-primary","key":2})]);
}

CandleHolder.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = CandleHolder;

CandleHolder.default = CandleHolder;
